module.exports = __webpack_public_path__ + "img/current-location.4582202a.svg";